export default {
  init() {

  },
  finalize() {
    const $popout = $('.bits-team-member-popout');
    const $featuredMemberCta = $('.is-featured-member-dynamic-cta');
    const $featuredMemberCard = $('.bits-team-member-card.featured-member-card .team-member-link');

    // Find .cta-btn-wrap a in $featuredMemberCta and trigger click event -> click on $featuredMemberCard
    $featuredMemberCta.find('.cta-btn-wrap a').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $featuredMemberCard.trigger('click');
    });

    $('.team-member-link').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const $teamMember = $(this).parent();

      const profileImage = $teamMember.find('.team-member-image').attr('src');
      const memberName = $teamMember.find('.member-name').html();
      const $memberPosition = $teamMember.find('.member-position');
      const $memberLocation = $teamMember.find('.meta-location .meta-text');
      const $memberEmail = $teamMember.find('.meta-email .meta-text');
      const $additionalInfo = $teamMember.find('.additional-info-full-text');

      $popout.find('.profile-picture').attr('src', profileImage);
      $popout.find('.profile-info-name').html(memberName);

      if ($memberPosition.length > 0) {
        $popout.find('.profile-info-position').removeClass('d-none').html($memberPosition.html());
      } else {
        $popout.find('.profile-info-position').addClass('d-none');
      }

      if ($memberLocation.length == 0 && $memberEmail.length == 0) {
        $popout.find('.profile-contactables').addClass('d-none');
      } else {
        $popout.find('.profile-contactables').removeClass('d-none');
      }

      if ($memberLocation.length > 0) {
        $popout.find('.contactable-location').removeClass('d-none');
        $popout.find('.contactable-location .contactable-text').html($memberLocation.html());
      } else {
        $popout.find('.contactable-location').addClass('d-none');
      }

      if ($memberEmail.length > 0) {
        $popout.find('.contactable-email').removeClass('d-none');
        $popout.find('.contactable-email .contactable-text').html($memberEmail.html());
      } else {
        $popout.find('.contactable-email').addClass('d-none');
      }

      if ($additionalInfo.length > 0) {
        $popout.find('.additional-info').html($additionalInfo.html());
      }

      $('body').addClass('overflow-hidden');
      $popout.addClass('open');
    });

    // Click-off popout
    $(window).on('click', function(e) {
      if (e.target.classList.contains('bits-team-member-popout')) {
        $('body').removeClass('overflow-hidden');
        $popout.removeClass('open');
      }
    });

    // Close popout
    $popout.find('.close-btn').on('click', function() {
      $('body').removeClass('overflow-hidden');
      $popout.removeClass('open');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateMeetTheTeam.js